export const durationIso8601ToHour = (duration: string) =>
  Number(duration?.slice(duration.indexOf('T') + 1, duration.indexOf('H')));
